export const standardizeWarnScore = (value, exceedLevel) => {
    const hasNoSignal = value === null || value === -99999;
    const numericExceedLevel = Number(exceedLevel);
    return hasNoSignal ? 0.5 : (Number.isFinite(numericExceedLevel) ? numericExceedLevel : 0);
};

const hasUsableCoordinates = item => {
    const longitude = Number(item?.longtitude);
    const latitude = Number(item?.latitude);

    return Number.isFinite(longitude) && Number.isFinite(latitude) &&
        longitude !== 0 && latitude !== 0;
};

export const isDashboardMapItem = item =>
    Number.isFinite(item?.position?.lng) && Number.isFinite(item?.position?.lat);

export const buildDashboardMapItems = (
    instrumentExtends,
    statusEntries,
    getGageTypeKey = gageTypeCode => String(gageTypeCode)
) => {
    const statusByPointIdx = new Map(
        (Array.isArray(statusEntries) ? statusEntries : [])
            .filter(item => item?.pointIdx != null)
            .map(item => [String(item.pointIdx), item])
    );
    const coordinateGroups = {};
    const items = [];
    const missingPointIndices = [];

    (Array.isArray(instrumentExtends) ? instrumentExtends : [])
        .filter(hasUsableCoordinates)
        .forEach(instrumentExtend => {
            const statusItem = statusByPointIdx.get(String(instrumentExtend.pointIdx));
            if (!statusItem) {
                missingPointIndices.push(instrumentExtend.pointIdx);
                return;
            }

            const item = {
                ...statusItem,
                position: {
                    lng: Number(instrumentExtend.longtitude),
                    lat: Number(instrumentExtend.latitude)
                },
                jsxMasterExceedWarning: standardizeWarnScore(
                    statusItem.value,
                    statusItem.exceedWarning
                ),
                jsxGageTypeKey: getGageTypeKey(statusItem.gageTypeCode)
            };
            const coordinateKey = `${item.position.lng},${item.position.lat}`;

            if (!coordinateGroups[coordinateKey]) {
                coordinateGroups[coordinateKey] = { children: [] };
                items.push(item);
            } else {
                coordinateGroups[coordinateKey].children.push(item);
            }
        });

    items.forEach(item => {
        const coordinateKey = `${item.position.lng},${item.position.lat}`;
        const children = coordinateGroups[coordinateKey].children;
        item.jsxMasterExceedWarning = children.reduce(
            (highestScore, child) => Math.max(
                highestScore,
                standardizeWarnScore(child.value, child.exceedWarning)
            ),
            standardizeWarnScore(item.value, item.exceedWarning)
        );
    });

    return { items, coordinateGroups, missingPointIndices };
};
